import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'sv',
    fullName: 'Swedish',
    nativeName: 'Svenska',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Något fantastiskt kommer",
    landing_subtitle: "ArgVoid är en app- och spelutvecklingsstudio. Håll utkik, nya saker kommer snart!",
    select_language: "Välj Språk",
    search_placeholder: "Sök efter språk...",
    terms_title: "Användarvillkor",
    policy_title: "Sekretesspolicy",
    cookies_title: "Cookiepolicy",
    terms_content: `
        <strong>1. Godkännande av Villkor</strong><br>
        Genom att komma åt ArgVoid accepteras dessa användarvillkor. Om dessa villkor inte godkänns ska tjänsten inte användas.<br><br>

        <strong>2. Plattformsanvändning</strong><br>
        ArgVoid och dess applikationer tillhandahålls "i befintligt skick" för informations- och kreativa syften. Tjänsten får endast användas för lagliga ändamål.<br><br>

        <strong>3. Förbjudet beteende</strong><br>
        Det är strängt förbjudet att utnyttja sårbarheter på webbplatsen, spam eller försöka obehörig åtkomst till infrastrukturen.<br><br>

        <strong>4. Ansvarsfriskrivning</strong><br>
        Plattformen och tjänsterna kan ändras när som helst utan föregående meddelande. Ingen garanti ges angående drifttiden eller tillgängligheten för tjänsten.
    `,
    policy_content: `
        <strong>1. Informationssamling</strong><br>
        Plattformen kräver inte användarautentisering eller kontoskapande för närvarande. Ingen personlig identifieringsinformation (som namn eller e-postadresser) samlas aktivt in från besökare.<br><br>

        <strong>2. Användningsdata</strong><br>
        Grundläggande, anonymiserad analys kan samlas in för att förstå webbplatstrafiken och förbättra applikationerna. Denna data är inte kopplad till individuella användaridentiteter.<br><br>

        <strong>3. Tredjepartstjänster</strong><br>
        Tredjepartsleverantörer kan användas för värd- och analystjänster. Dessa respektive leverantörers sekretesspraxis styr de anonyma uppgifter som behandlas på deras infrastruktur.<br><br>

        <strong>4. Datasäkerhet</strong><br>
        Rimliga säkerhetsåtgärder genomförs för att skydda plattformen. Ingen överföringsmetod över Internet är dock helt säker.<br><br>
    `,
    cookies_content: `
        <strong>1. Vad är cookies och lokal lagring?</strong><br>
        Cookies och lokal lagring i webbläsaren är små datafiler som lagras på enheten för att komma ihåg konfigurationsinställningar över besök.<br><br>

        <strong>2. Användningsändamål</strong><br>
        Browser LocalStorage används strikt för att spara konfigurationsinställningar, såsom:<br>
        - Språkinställningar<br>
        - Användargränssnittskonfiguration (t.ex. layout eller temainställningar) <br>
        - Tillfällig applikationscache<br><br>

        <strong>3. Ingen spårning</strong><br>
        Cookies och lokal lagring används inte för reklam eller tredje parts spårningsändamål. All lagrad data är strikt för plattformens kärnfunktionalitet.<br><br>

        <strong>4. Kontroll</strong><br>
        Webbläsardata kan raderas när som helst via webbläsarinställningarna, vilket återställer alla lokala konfigurationer.
    `,
    cookie_consent_text: "Vi använder grundläggande cookies för att säkerställa att webbplatsen fungerar korrekt, som att hålla din session aktiv, spara dina språkinställningar och andra anpassade konfigurationer.",
    read_policy: "Läs Cookie Policy",
    support_title: "Kontakta support",
    support_subject_label: "Ämne",
    support_message_label: "Meddelande",
    support_submit_button: "Skicka meddelande",
    support_hint: "Obs! Detta öppnar ditt standardprogram för e-post för att skicka meddelandet.",
    support_success_msg: "Öppnar din e-postapp...",
    support_error_msg: "Det gick inte att skicka meddelandet. Försök igen senare.",
    explorer_title: "Utforskare",
    history_title: "Historia",
    animation_title: "Animation",
    config_title: "Konfiguration",
    tool_mouse: "Välj (Ctrl+M)",
    tool_brush: "Pensel (Ctrl+B)",
    tool_brush_mode: "Växla läge (fast/klart)",
    tool_eraser: "Suddgummi (Ctrl+E)",
    tool_brush_size: "Justera borststorleken",
    tool_bucket: "Fyll (Ctrl+F)",
    tool_eyedropper: "Pipett",
    tool_grid: "Rutnät (Ctrl+Skift+B)",
    tool_rotate: "Rotera (Ctrl+Skift+R)",
    tool_flip_h: "Vänd H (Ctrl+Skift+H)",
    tool_flip_v: "Vänd V (Ctrl+Skift+V)",
    tool_transpose: "Transponera (Ctrl+Skift+T)",
    label_width: "Bredd",
    label_height: "Höjd",
    label_frames: "Antal ramar",
    label_animation: "Animation stil",
    label_background_color: "Bakgrundsfärg",
    label_interval: "Intervall",
    tool_anim_config: "Animeringskonfiguration",
    label_new_width: "Ny bredd",
    label_new_height: "Ny höjd",
    label_apply: "Tillämpas",
    label_colors: "Färger",
    label_size: "Storlek",
    label_tolerance: "Tolerans",
    val_horizontal: "Horisontell",
    val_vertical: "Vertikal",
    val_sequence: "Sekvens",
    val_bounce: "Studsa",
    val_random: "Slumpmässig",
    val_solid: "Fast",
    val_clear: "Rensa",
    action_add_sheet: "Nytt ark",
    action_import: "Importera",
    action_export: "Exportera",
    action_sort_projects: "Sortera",
    sort_date_old: "Äldst först",
    sort_date_new: "Nyaste först",
    sort_name_az: "Namn (A-Z)",
    sort_name_za: "Namn (Z-A)",
    action_new_sprite: "Ny Sprite",
    action_new_project: "Nytt projekt",
    modal_save_all_title: "Spara alla ändringar",
    modal_save_all_desc: "Välj tillgångarna att spara:",
    modal_save_selected: "Spara valda",
    action_saved: "Sparad",
    modal_create_sprite_title: "Skapa ny Sprite",
    modal_create_project_title: "Skapa nytt projekt",
    modal_add_sheet_title: "Lägg till nytt blad",
    modal_rename_sheet_title: "Byt namn på ark",
    modal_rename_sprite_title: "Byt namn på Sprite",
    modal_delete_sprite_title: "Ta bort Sprite",
    modal_delete_project_title: "Ta bort projekt",
    modal_delete_sheet_title: "Ta bort ark",
    placeholder_sprite_name: "Namn",
    placeholder_project_name: "Namn",
    placeholder_sheet_name: "Namn",
    placeholder_new_name: "Nytt namn",
    action_create: "Skapa",
    action_add: "Tillägga",
    action_rename: "Döpa om",
    action_duplicate: "Duplicera",
    action_delete: "Radera",
    action_cancel: "Avboka",
    confirm_delete_sprite: "Är du säker på att du vill ta bort den här spriten?",
    confirm_delete_project: "Är du säker på att du vill ta bort det här projektet? Alla sprites kommer att tas bort.",
    confirm_delete_sheet: "Är du säker på att du vill ta bort det här bladet?",
    err_select_sprite: "Välj en sprite först.",
    err_select_project: "Välj ett projekt först.",
    err_name_empty: "Namnet får inte vara tomt.",
    err_sprite_exists: "En sprite med det namnet finns redan.",
    err_project_exists: "Ett projekt med det namnet finns redan.",
    err_no_content: "Inget innehåll att spara.",
    err_no_changes: "Inga ändringar att spara.",
    err_delete_last_sheet: "Det går inte att ta bort det sista arket.",
    err_extract_frames: "Det gick inte att extrahera några ramar.",
    err_indexeddb: "Det gick inte att spara lokalt. Din webbläsare kanske inte stöder IndexedDB.",
    msg_upload_success: "Uppladdningen lyckades: {0}",
    msg_upload_failed: "Uppladdningen misslyckades: {0}",
    msg_save_success: "Spara lyckades.",
    msg_saving: "Sparande...",
    msg_multi_save_result: "Sparade {0} tillgångar. {1} misslyckanden.",
    menu_title: "Meny",
    menu_save: "Spara",
    menu_save_all: "Spara alla",
    menu_support: "Kontakta support",
    label_local_storage: "Lokal förvaring",
    label_sign_in: "Logga in",
    modal_export_title: "Exportera Sprite",
    label_filename: "Filnamn",
    label_format: "Formatera",
    action_export_confirm: "Exportera",
};

export default translations;
